import { PureComponent } from 'react'
import { userActions } from '../redux/actions/userActions'
import { connect } from 'react-redux'

class LogOut extends PureComponent {
  componentWillMount () {
    this.props.dispatch(userActions.logout());
  }
  
  render () {
    return null;
  }
}

export default connect()(LogOut);


// WEBPACK FOOTER //
// ./src/pages/LogOut.js